import axios from 'axios';

export const authUserApi = (login, password) => {
    return axios.post('/api/auth', { login, password });
}
